// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Mn7aO","disabled":"FileBtn_disabled__2n9I5","warn":"FileBtn_warn__L61lB","fade":"FileBtn_fade__2dOxe"};